import { last, get, memoize } from 'lodash';

import tokenize, { CharacterToken, Token, TokenBase } from './tokenizer';

export const getTokens = tokenize;

export type StringToken = TokenBase<'string', string>;

export type ParagraphItem = Exclude<Token, CharacterToken> | StringToken;

export class Paragraph {
  constructor(public items: ParagraphItem[] = []) {}

  push(item: ParagraphItem) {
    this.items.push(item);
  }

  getLastItem() {
    return last(this.items);
  }

  getLastItemType() {
    return get(this.getLastItem(), 'type');
  }

  mergeWithLastItem(item: CharacterToken) {
    const lastItem = this.getLastItem() as StringToken;
    const data = `${lastItem.data}${item.data}`;

    this.items[this.items.length - 1] = {
      ...lastItem,
      data,
    };
  }

  isEmpty() {
    return this.items.length === 0;
  }
}

export default memoize((tokens: Token[]) => {
  const paragraphs = tokens.reduce(
    (result, token) => {
      const current = last(result) as Paragraph;

      switch (token.type) {
        case 'newline':
          result.push(new Paragraph());
          break;
        case 'character':
          if (current.getLastItemType() === 'string') {
            current.mergeWithLastItem(token);
          } else {
            current.push({
              ...token,
              type: 'string',
            });
          }
          break;
        case 'eof':
          return result;
        default:
          current.push(token);
          break;
      }

      return result;
    },
    [new Paragraph()]
  );

  return {
    paragraphs: paragraphs.filter((paragraph) => !paragraph.isEmpty()),
  };
});
